import HelperService from "../../../StarterKit/Service/Bll/HelperService";
import ApiProduct from "../Api/ApiProduct";
import ApiFilter from "../Api/ApiFilter";

export default class FilterService {
    #helper;
    #api;

    constructor() {
        this.#api = new ApiFilter();
        this.#helper = new HelperService();
    }


    async destroyed(key, form) {
        const result = await this.#api.destroy(key, form);
        return result;
    }

    async listFromModel(){
        const result = await this.#api.listFromModel();
        return result;
    }
}
